import { resolvePriceClientType } from './clientType';
import { buildLineKey } from './documentLineItems';

export const computeClientPricingDiscountAmount = (price, discount) => {
  const basePrice = Math.max(0, Math.floor(Number(price || 0)));
  if (!discount || basePrice <= 0) return 0;
  const value = Math.max(0, Number(discount.discountValue || 0));
  const raw = discount.discountType === 'percent'
    ? Math.floor(basePrice * (value / 100))
    : Math.floor(value);
  return Math.min(Math.max(raw, 0), basePrice);
};

const cloneMatrix = (matrix = {}) => {
  const next = {};
  Object.keys(matrix || {}).forEach((key) => {
    next[key] = Array.isArray(matrix[key]) ? [...matrix[key]] : [];
  });
  return next;
};

const normalizeDiscountMap = (discountsByVarietyPriceId = {}) => {
  if (discountsByVarietyPriceId instanceof Map) return discountsByVarietyPriceId;
  return new Map(
    Object.entries(discountsByVarietyPriceId || {})
      .map(([key, value]) => [Number(key), value])
      .filter(([key]) => Number.isInteger(key))
  );
};

export const applyClientPricingDiscountsToMatrices = ({
  products = [],
  discounts = {},
  linePriceMeta = {},
  discountsByVarietyPriceId = {},
}) => {
  const discountMap = normalizeDiscountMap(discountsByVarietyPriceId);
  const nextDiscounts = cloneMatrix(discounts);
  const nextLinePriceMeta = { ...(linePriceMeta || {}) };
  let changed = false;

  (products || []).forEach((product) => {
    (product.Varieties || []).forEach((variety) => {
      (variety.VarietyPrices || []).forEach((price, priceIndex) => {
        if (resolvePriceClientType(price) !== 'mayorista') return;
        const key = buildLineKey(variety.id, priceIndex);
        const meta = nextLinePriceMeta[key] || {};
        const currentDiscount = Number(nextDiscounts[variety.id]?.[priceIndex] || 0);
        const entry = discountMap.get(Number(price.id));
        const categoryDiscount = computeClientPricingDiscountAmount(price?.price, entry);

        if (!nextDiscounts[variety.id]) nextDiscounts[variety.id] = [];

        if (!entry || categoryDiscount <= 0) {
          if (meta.discountSource === 'client_category') {
            nextDiscounts[variety.id][priceIndex] = 0;
            nextLinePriceMeta[key] = { ...meta, discountSource: 'none' };
            changed = true;
          }
          return;
        }

        const shouldPreserveManual = meta.discountSource === 'manual' && currentDiscount > categoryDiscount;
        if (shouldPreserveManual) return;

        if (currentDiscount !== categoryDiscount || meta.discountSource !== 'client_category') {
          nextDiscounts[variety.id][priceIndex] = categoryDiscount;
          nextLinePriceMeta[key] = {
            ...meta,
            discountSource: 'client_category',
            clientPricingCategoryId: entry.clientPricingCategoryId || null,
            clientPricingCategoryName: entry.clientPricingCategoryName || null,
          };
          changed = true;
        }
      });
    });
  });

  return { discounts: nextDiscounts, linePriceMeta: nextLinePriceMeta, changed };
};
